<script lang="ts">
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()

    export let checked: boolean = false
    export let label: string = null
    export let cssClass: string = ""

    const toggle = () => {
        checked = !checked
        if (checked) {
            dispatch("checked")
        } else {
            dispatch("unchecked")
        }
    }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="radiobutton {cssClass}"
    class:checked
    class:with-label="{label}"
    on:keydown|stopPropagation
    on:click|stopPropagation="{toggle}"
>
    <div class="input-radiobutton">
        <div class="input-radiobutton-content">
            {#if checked}
                <div class="radiobutton-checked"></div>
            {/if}
        </div>
    </div>

    {#if label}
        <label for="">
            {label}
            <slot />
        </label>
    {/if}
</div>
